export const maybeParseFloat = (val?: string | number | null) => {
  if (typeof val === 'number') return val;
  return val ? parseFloat(val) : undefined;
};
